import styled from '@emotion/styled'

const NoDataCard = styled.div`
  margin: 0;
  padding: 0 0 5em 0;
`

export default NoDataCard
